import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Switch } from "antd";

import ModalComponent from "components/modalComponent/ModalComponent";

class ClientsManagementContent extends PureComponent {
	updateClient = switchStatus => {
		const { onChangeSwitchClientsManagement, client } = this.props;

		onChangeSwitchClientsManagement(client.id, switchStatus);
	};

	render() {
		const { client, checked } = this.props;

		return (
			<div className="p-al-full p-mrg-ver">
				<span>{client.label}</span>
				<Switch
					checked={checked}
					onChange={switchStatus => this.updateClient(switchStatus)}
				/>
			</div>
		);
	}
}

class ModalClientsManagement extends PureComponent {
	render() {
		const {
			user,
			showModal,
			closeModal,
			userClients,
			clientsList,
			onChangeSwitchClientsManagement,
		} = this.props;
		const userClientsList = userClients.map(userClient => userClient.id);

		return (
			<ModalComponent
				title="GESTION DES CLIENTS"
				showModal={showModal}
				closeModal={closeModal}
				{...this.props}
			>
				<div className="p-mrg-bot-l p-clr-mdg">{user.email}</div>
				<div>
					{clientsList.map((client, i) => (
						<ClientsManagementContent
							key={i}
							client={client}
							onChangeSwitchClientsManagement={onChangeSwitchClientsManagement}
							checked={userClientsList.includes(client.id)}
						/>
					))}
				</div>
			</ModalComponent>
		);
	}
}

ClientsManagementContent.propTypes = {
	client: PropTypes.object,
	onChangeSwitchClientsManagement: PropTypes.function,
};

ModalClientsManagement.propTypes = {
	showModal: PropTypes.boolean,
	closeModal: PropTypes.function,
	userClients: PropTypes.array,
	clientsList: PropTypes.array,
	onChangeSwitchClientsManagement: PropTypes.function,
};

export default ModalClientsManagement;



// WEBPACK FOOTER //
// src/containers/admin/users/ModalClientsManagement.js